/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Search_ArtifactsInputs */



/**
* | output |
* | --- |
* | "Search artifacts..." |
*
* @param {Project_Search_ArtifactsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_search_artifacts = /** @type {((inputs?: Project_Search_ArtifactsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Search_ArtifactsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakte suchen...")
	return /** @type {LocalizedString} */ ("Search artifacts...")
});